import { useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Context } from "../ContextProvider";
import allsafeLogo from "../assets/icons/allsafe_logo.svg";

const Header = () => {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useContext(Context);

  const handleLangChange = (e: any) => {
    const lang = e.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <header data-testid="header">
      <div className="fixed flex justify-between items-center bg-allsafe-white shadow-md w-full z-20 h-24 pl-4 pr-8">
        <div className="h-16 w-16">
          <img src={allsafeLogo} alt="logo" className="w-full h-full" />
        </div>
        <div className="relative overflow-hidden">
          <select
            name="lang"
            id="lang"
            onChange={handleLangChange}
            value={language}
            className="font-Roboto cursor-pointer w-16 h-8 bg-allsafe-grey hover:bg-gray-200 shadow-3xl appearance-none bg-[url('./assets/icons/arrow.svg')] bg-no-repeat	bg-[90%_50%] rounded-md outline-none indent-2"
          >
            <option value="de">DE</option>
            <option value="en">EN</option>
            <option value="fr">FR</option>
          </select>
        </div>
      </div>
      <div className="relative top-24 bg-allsafe-grey-100">
        <div className="text-center w-full h-full text-allsafe-blue text-4xl leading-9 font-Roboto font-medium pl-8 py-14">
          <Trans i18nKey="safetyOrderRearGarage">
            Sicherheit und Ordnung in der Heckgarage
          </Trans>
        </div>
      </div>
    </header>
  );
};

export default Header;
